import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import localForage from "localforage";
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBalanceWalletOutlined from '@material-ui/icons/AccountBalanceWalletOutlined';
import InsertDriveFileOutlined from '@material-ui/icons/InsertDriveFileOutlined';
import DescriptionOutlined from '@material-ui/icons/DescriptionOutlined';
import AccountCircleOutlined from '@material-ui/icons/AccountCircleOutlined';
import ExitToAppOutlined from '@material-ui/icons/ExitToAppOutlined';
import Drawer from '@material-ui/core/Drawer';

import { changeDrawerState } from '../../../redux/actions/drawerActions'
import { signOut } from '../../../redux/actions/authActions'
import { ACCOUNT_TYPE_VOLUNTEER } from '../../shared/constants';

const styles = theme => ({
  flexMenuWrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  }
});

class DrawerCustomDesktop extends React.PureComponent {

  toggleDrawer = () => {
    this.props.dispatch(changeDrawerState());
  }

  handleSignOut = () => {
    localForage.removeItem('account').then(() => {
      this.props.dispatch(signOut());
      this.props.dispatch(changeDrawerState());
      window.location = '/auth/login';
    });
  }

  handleLinkTo = link => event => {

    this.props.dispatch(changeDrawerState());
    this.props.history.push(link);
  }

  render() {
    const { classes } = this.props;
    return (
      <Drawer 
        disableBackdropTransition
        variant="permanent"
        style={{zIndex: 0, position: 'relative'}}
      >
        <div
          tabIndex={0}
          role="button"
          className={classes.flexMenuWrapper}
        >
          <div style={{width: 250, flexGrow: 2, display: 'flex', alignItems: 'flex-start'}}>
            <List style={{width: '100%', marginTop: 90}}>
              <div>
                <ListItem button onClick={this.handleLinkTo('/account/profile')}>
                  <ListItemIcon>
                    <AccountCircleOutlined />
                  </ListItemIcon>
                  <ListItemText primary="Editar Perfil" />
                </ListItem>
                <Divider light />
                <ListItem button>
                  <ListItemIcon>
                    <InsertDriveFileOutlined />
                  </ListItemIcon>
                  <ListItemText primary="Test" onClick={this.handleLinkTo('/account/home?at=0')} />
                </ListItem>
                <Divider light />
                <ListItem button>
                  <ListItemIcon>
                    <DescriptionOutlined />
                  </ListItemIcon>
                  <ListItemText primary="Test en Curso" onClick={this.handleLinkTo('/account/home?at=1')} />
                </ListItem>
                <Divider light />
                {this.props.auth.account_type === ACCOUNT_TYPE_VOLUNTEER && (
                <React.Fragment>
                  <ListItem button>
                    <ListItemIcon>
                      <DescriptionOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Información médica" onClick={this.handleLinkTo('/account/medical-information')} />
                  </ListItem>
                  <Divider light />
                  
                  <ListItem button>
                    <ListItemIcon>
                      <AccountBalanceWalletOutlined />
                    </ListItemIcon>
                    <ListItemText primary="Pagos" />
                  </ListItem>
                </React.Fragment>
                )}
              </div>
            </List>
          </div>
          <div style={{flexGrow: 1, display: 'flex', alignItems: 'flex-end', width: '100%', justifyContent: 'flex-end', padding: 20}}>
            <IconButton onClick={this.handleSignOut}>
              <ExitToAppOutlined />
            </IconButton>
          </div>
        </div>
      </Drawer>
    )
  }
}

export default withRouter(
  connect(state => ({
    drawerOpened: state.drawer.open,
    auth: state.auth
  }))(withStyles(styles)(DrawerCustomDesktop))
)


// WEBPACK FOOTER //
// ./src/modules/shared/components/DrawerCustomDesktop.js